import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { authFetch } from "../utils/authFetch";

const user = JSON.parse(localStorage.getItem("user") || "{}");

function RFQListPage() {
  const [rfqs, setRfqs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [ccEmails, setCcEmails] = useState("");
  const itemsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    authFetch(`${process.env.REACT_APP_API_URL}/rfq-summary`)
      .then((res) => res.json())
      .then((data) => setRfqs(data))
      .catch((err) => console.error("Error fetching RFQs:", err));
  }, []);

  const filteredRfqs = useMemo(() => {
    return rfqs.filter((rfq) =>
      rfq.site_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [rfqs, searchTerm]);

  const currentData = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return filteredRfqs.slice(start, start + itemsPerPage);
  }, [filteredRfqs, currentPage]);

  const handleResend = async (vendorId, rfqId) => {
    try {
      const response = await authFetch(`${process.env.REACT_APP_API_URL}/api/rfq/resend`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ vendorId, rfqId, cc_emails: ccEmails }),
      });
      const data = await response.json();
      
      if (data.success) {
        // Update local state to reflect the change immediately
        setRfqs(prevRfqs => 
          prevRfqs.map(rfq => 
            rfq.id === rfqId 
              ? { 
                  ...rfq, 
                  vendors: rfq.vendors.map(v => v.id === vendorId ? { ...v, mail_sent: true } : v) 
                } 
              : rfq
          )
        );
        alert("Email resent successfully!");
      } else {
        alert("Failed to resend: " + data.error);
      }
    } catch (err) {
      alert("Error connecting to server.");
    }
  };

  const handleDelete = async (rfqId) => {
  if (!window.confirm("Delete this RFQ?")) return;

  try {
    const res = await authFetch(
      `${process.env.REACT_APP_API_URL}/delete-rfq/${rfqId}`,
      {
        method: "DELETE",
      }
    );

    if (res.ok) {
      setRfqs((prev) => prev.filter((r) => r.id !== rfqId));
      alert("RFQ deleted successfully");
    } else {
      alert("Failed to delete RFQ");
    }
  } catch (err) {
    alert("Server error");
  }
};
  return (
    <div style={{ padding: "30px", maxWidth: "1200px", margin: "auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "25px" }}>
        <div>
          <h1 style={{ margin: 0, fontSize: "34px", color: "#0f172a" }}>RFQ List</h1>
          <p style={{ color: "#64748b" }}>Manage and resend RFQ requests to vendors.</p>
        </div>
        <input 
          type="text" 
          placeholder="Search by site..."
          style={{ padding: "10px", borderRadius: "8px", border: "1px solid #cbd5e1" }}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div style={{ marginBottom: "20px" }}>
        <label style={{ display: "block", fontSize: "12px", fontWeight: "700", color: "#475569" }}>
          CC Emails <span style={{ fontWeight: "400", color: "#94a3b8" }}>(optional, comma-separated)</span>
          <input
            type="text"
            value={ccEmails}
            onChange={(e) => setCcEmails(e.target.value)}
            placeholder="Enter one or more CC email addresses for resend"
            style={{ display: "block", width: "100%", maxWidth: "520px", marginTop: "7px", padding: "10px 12px", border: "1px solid #cbd5e1", borderRadius: "8px", boxSizing: "border-box" }}
          />
        </label>
      </div>

      <div style={{ background: "#fff", borderRadius: "18px", padding: "20px", boxShadow: "0 2px 12px rgba(0,0,0,0.05)" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
  <tr style={{ background: "#f8fafc", textAlign: "left" }}>
    <th style={thStyle}>RFQ ID</th>
    <th style={thStyle}>Site</th>
    <th style={thStyle}>Vendors</th>
    <th style={thStyle}>Mail Sent</th>
    <th style={thStyle}>Quotes</th>
    <th style={thStyle}>Status</th>
    <th style={thStyle}>Action</th>
  </tr>
</thead>
        <tbody>
  {currentData.map((rfq) => (
    <tr key={rfq.id} style={{ borderBottom: "1px solid #e2e8f0" }}>
      <td style={tdStyle}>RFQ-{rfq.id}</td>

      <td style={tdStyle}>
        {rfq.site_name}
      </td>

      <td style={tdStyle}>
        {rfq.total_vendors}
      </td>

      <td style={tdStyle}>
        {rfq.mail_sent}/{rfq.total_vendors}
      </td>

      <td style={tdStyle}>
        {rfq.quotations_received}/{rfq.total_vendors}
      </td>

      <td style={tdStyle}>
        <span
          style={{
            padding: "6px 10px",
            borderRadius: "20px",
            background:
              rfq.status === "Approved"
                ? "#dcfce7"
                : "#fef3c7",
            color:
              rfq.status === "Approved"
                ? "#166534"
                : "#92400e",
            fontWeight: "600",
            fontSize: "12px",
          }}
        >
          {rfq.status}
        </span>
      </td>

      <td style={tdStyle}>
  <button
    onClick={() => navigate(`/rfq-details/${rfq.id}`)}
    style={viewBtn}
  >
    View
  </button>

  {user.role === "admin" || user.role === "purchase"&& (
    <button
      onClick={() => handleDelete(rfq.id)}
      style={{
        marginLeft: "8px",
        background: "#dc2626",
        color: "#fff",
        border: "none",
        padding: "8px 12px",
        borderRadius: "6px",
        cursor: "pointer",
      }}
    >
      Delete
    </button>
  )}
</td>
    </tr>
  ))}
</tbody>
        </table>
      </div>
    </div>
  );
}

const thStyle = { padding: "15px", fontSize: "14px", color: "#475569" };
const tdStyle = { padding: "16px", fontSize: "14px", color: "#0f172a" };
const viewBtn = { background: "#2563eb", color: "#fff", border: "none", padding: "8px 12px", borderRadius: "6px", cursor: "pointer" };
const resendBtn = { color: "#fff", border: "none", padding: "4px 8px", borderRadius: "4px", cursor: "pointer", fontSize: "10px", fontWeight: "bold" };

export default RFQListPage;
